import React from 'react';

export default function( props ){
    return(
            <i className="fa fa-circle-o-notch fa-spin" {...props} />
    );
}